/* eslint-disable max-len */
/* eslint-disable radix */
/* eslint-disable no-console */
/* eslint-disable no-alert */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');

const config = require('./config');
const BASE_URL = config.baseUrl;

class Scratch3Emo {
    constructor (runtime) {
        this.runtime = runtime;
        this._result = '';
        this._url = '';
        this._result = '';
        this._refresh_key = '';
        this._access_token = '';
        this._rooms = [];
        this._room_index = 0;
        this._sensors = '';
        this._socket = null;
        this._isConnectedWebsocket = false;
        this._websocketData = {};
        this._receivedMessage = '';
        this._receivedCommand = '';
        this._receivedRadar = '';
        this._receivedSensorName = '';
        this._receivedSensorAction = '';
        this._requestId = '';// 自分が送信したメッセージが循環してしまうので、UUIDを覚えておく
    }
    getInfo () {
        return {
            id: 'BOCCOemo',
            name: 'BOCCO\nemo',
            color1: '#383838', // ブロックのメイン色
            color2: '#080808', // ブロックの影の色
            blockIconURI:
                'data:image/png;base64,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', // NOTE: アイコン画像のbase64
            blocks: [
                {
                    opcode: 'setRefreshAPIKey',
                    blockType: BlockType.REPORTER,
                    text: 'リフレッシュトークンを設定',
                    disableMonitor: true
                },
                {
                    opcode: 'getRooms',
                    blockType: BlockType.REPORTER,
                    text: '部屋一覧を確認',
                    disableMonitor: true
                },
                '---',
                {
                    opcode: 'setRoomIndex',
                    blockType: BlockType.COMMAND,
                    text: '[TEXT]番の部屋を指定',
                    arguments: {
                        TEXT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'sendText',
                    blockType: BlockType.COMMAND,
                    text: '[TEXT]と言う',
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: 'こんにちは！'
                        }
                    }
                },
                {
                    opcode: 'moveHead',
                    blockType: BlockType.COMMAND,
                    text: '首の角度を変える 横 [ANGLE]度, 縦 [VERTICAL_ANGLE]度',
                    arguments: {
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        VERTICAL_ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'changeLed',
                    blockType: BlockType.COMMAND,
                    text: 'ほっぺの色を変える R: [RED] G: [GREEN] B: [BLUE]',
                    arguments: {
                        RED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 255
                        },
                        GREEN: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 255
                        },
                        BLUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 255
                        }
                    }
                },
                {
                    opcode: 'doPreMotion',
                    blockType: BlockType.COMMAND,
                    text: 'モーション[uuid]を再生',
                    arguments: {
                        uuid: {
                            type: ArgumentType.STRING,
                            menu: 'presetMotions',
                            defaultValue: config.motions[39].value
                        }
                    }
                },
                {
                    opcode: 'callbackWebsocket',
                    blockType: BlockType.HAT,
                    text: 'イベント[type]受信',
                    arguments: {
                        type: {
                            type: ArgumentType.STRING,
                            menu: 'webhookEvents',
                            defaultValue: config.webhookEvents[0].value
                        }
                    }
                },
                {
                    opcode: 'getRecievedMessage',
                    blockType: BlockType.REPORTER,
                    text: '新着メッセージの本文',
                    disableMonitor: true
                },
                {
                    opcode: 'getRecievedCommand',
                    blockType: BlockType.REPORTER,
                    text: '認識した音声コマンド',
                    disableMonitor: true
                },
                {
                    opcode: 'getRecievedSensorName',
                    blockType: BlockType.REPORTER,
                    text: '反応したセンサの名前',
                    disableMonitor: true
                },
                {
                    opcode: 'getRecievedSensorAction',
                    blockType: BlockType.REPORTER,
                    text: 'センサの反応の種類',
                    disableMonitor: true
                }
            ],
            menus: {
                presetMotions: {
                    acceptReporters: true,
                    items: config.motions
                },
                webhookEvents: {
                    acceptReporters: true,
                    items: config.webhookEvents
                }
            }
        };
    }
    async setRefreshAPIKey () {
        // NOTE: ダイアログボックスを表示し、ユーザーにパスワードを入力させる
        if (this._refresh_key) { // 既に入力済みの場合
            return '既に入力済です';
        } // 新規入力の場合
        this._refresh_key = prompt(
            `BOCCO emo Platform APIのリフレッシュトークンを入力してください。\nこちらのURLよりログインし、取得してください。\n${config.baseUrl}/dashboard/`,
            config.refreshToken
        );
    
        try {
            await this.refreshToken();
            await this.getRoomId();
            await this.startWebsocket();
            alert('BOCCO emoの準備が完了しました。');
        } catch (error) {
            alert(`エラーが発生しました: ${error.message}`);
        }
    }
    async refreshToken () {
        const url = `${BASE_URL}/oauth/token/refresh`;
        try {
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({refresh_token: this._refresh_key})
            });
    
            if (!res.ok) {
                throw new Error(
                    'アクセストークンの取得に失敗しました。リフレッシュトークンをお確かめください。'
                );
            }
    
            const body = await res.json();
            this._access_token = body.access_token;
            this._refresh_key = body.refresh_token;
    
            // 50分後にアクセストークンの再取得
            if (this._access_token) {
                setTimeout(() => {
                    this.refreshToken();
                }, 50 * 60 * 1000);
            }
        } catch (error) {
            alert(error.message);
        }
    }
    async getRoomId () {
        const roomUrl = `${BASE_URL}/v1/rooms`;
        try {
            const res = await fetch(roomUrl, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${this._access_token}`
                }
            });
    
            const body = await res.text();
            const obj = JSON.parse(body);
            this._rooms = obj.rooms;
        } catch (error) {
            console.error('Error:', error);
        }
    }
    moveHead (args) {
        if (!this._access_token) {
            alert('リフレッシュトークンを設定してください。');
            return;
        }
        const angle = Cast.toNumber(args.ANGLE);
        const verticalAngle = Cast.toNumber(args.VERTICAL_ANGLE);
        const url = `${BASE_URL}/v1/rooms/${
            this._rooms[this._room_index].uuid
        }/motions/move_to`;
        if (angle < -45 || angle > 45) {
            alert('横の角度は-45から45までの値を入力してください。');
            return;
        }
        if ((verticalAngle < -20) | (verticalAngle > 20)) {
            alert('縦の角度は-20から20までの値を入力してください。');
            return;
        }

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${this._access_token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                angle: angle,
                vertical_angle: verticalAngle
            })
        })
            .then(res => {
                if (res.status === 429) {
                    throw new Error(
                        '制限に到達しました。しばらく待ってから実行してください。'
                    );
                }
                if (res.status === 401) {
                    alert(config.messages.unauthorized);
                }
                return res.json();
            })
            .catch(error => {
                console.error('Error:', error);
                alert(error);
            });
    }
    doPreMotion (args) {
        if (!this._access_token) {
            alert('リフレッシュトークンを設定してください。');
            return;
        }
        const uuid = Cast.toString(args.uuid);
        const url = `${BASE_URL}/v1/rooms/${
            this._rooms[this._room_index].uuid
        }/motions/preset`;
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${this._access_token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({uuid: uuid})
        })
            .then(res => {
                if (res.status === 429) {
                    throw new Error(
                        '制限に到達しました。しばらく待ってから実行してください。'
                    );
                }
                if (res.status === 401) {
                    alert(config.messages.unauthorized);
                }
                return res.json();
            })
            .catch(error => {
                console.error('Error:', error);
                alert(error);
            });
    }
    async startWebsocket () {
        if (this._isConnectedWebsocket && this._socket !== null){
            alert('イベント受信準備完了しています。');
            return;
        }
        
        return new Promise((resolve, reject) => {
            try {
                this._socket = new WebSocket(config.websocketUrl);
                
                this._socket.addEventListener('open', async event => {
                    // 接続が開かれた時の処理
                    this._websocketData = event;
                    try {
                        await Promise.all(
                            this._rooms.map(room => this._socket.send(`{"type": "join", "room_uuid": "${room.uuid}"}`))
                        );
                        this._isConnectedWebsocket = true;
                        setInterval(() => {
                            if (this._socket.readyState === WebSocket.OPEN) {
                                this._socket.send('{"type": "ping"}');
                            }
                        }, 30000); // 30秒ごとにpingを送信
                        resolve();
                    } catch (error) {
                        reject(error);
                    }
                });
    
                this._socket.addEventListener('message', event => {
                    // メッセージを受信した時の処理
                    try {
                        if (event.data === 'OK'){ // pongの場合
                            return;
                        }
                        const message = JSON.parse(event.data);
                        if (message.type === 'join'){ // joinへの応答（購読状況）はイベントではない
                            this.warnIfUnsubscribed(message);
                            return;
                        }
                        this._websocketData = message;
                    } catch (e){
                        console.log(e);
                    }
                });
    
                this._socket.addEventListener('error', event => {
                    // エラーが発生した時の処理
                    console.error('エラー:', event);
                    alert('BOCCO emoサーバとの接続でエラーが発生しました。');
                    reject(event);
                });
    
                this._socket.addEventListener('close', () => {
                    // 接続が閉じられた時の処理
                    alert('BOCCO emoサーバとの接続が切れました。ページをリロードして、再接続してください。作業途中の場合は、保存してからリロードしてくだい。');
                    this._isConnectedWebsocket = false;
                    resolve();
                });
    
            } catch (e){
                console.log(e);
                reject(e);
            }
        });
    }
    warnIfUnsubscribed (message) {
        // プログラミングエモちゃんを購読していない部屋には、サーバからイベントが届かない
        if (message.subscribed !== false) {
            return;
        }
        const room = this._rooms.find(r => r.uuid === message.room_uuid);
        const roomName = room ? `「${room.name}」` : 'この部屋';
        alert(`${roomName}はプログラミングエモちゃんチャンネルを購読していないため、イベント受信ブロックは動きません。\nアプリでプログラミングエモちゃんチャンネルを購読してから、ページを再読み込みしてください。作業途中の場合は、保存してからリロードしてください。`);
    }
    callbackWebsocket (args) {
        if (args.type === this._websocketData.event){
            // イベントの値を格納する処理
            if (this._websocketData.event === 'message.received'){
                if (this._requestId === this._websocketData.request_id){
                    this._websocketData = {};
                    return false;
                }
                this._receivedMessage = this._websocketData.data.message.message.ja;
            } else if (this._websocketData.event === 'vui_command.detected'){
                this._receivedCommand = this._websocketData.data.vui_command.kind;
            } else if (this._websocketData.event === 'radar.detected'){
                if (!(this._websocketData.data.radar.near_begin || this._websocketData.data.radar.begin)){ // 近接以外は無視（本線でも使っていない）
                    return false;
                }
            } else if (this._websocketData.event.endsWith('_sensor.detected')){
                // つみきセンサ（振動・鍵・人感・部屋）。イベント名の先頭部分がdataのキーと一致する
                const sensorKey = this._websocketData.event.split('.')[0];
                const sensorData = this._websocketData.data[sensorKey];
                this._receivedSensorName = sensorData.user.nickname;
                const actionLabel = config.sensorActions[sensorData.sensor_action];
                if (actionLabel) {
                    this._receivedSensorAction = actionLabel;
                } else {
                    console.error(`未登録のsensor_actionを受信しました: ${sensorData.sensor_action}`);
                    this._receivedSensorAction = sensorData.sensor_action;
                }
            }
            this._websocketData = {};
            return true;
        }
        return false;
    }
    getRecievedMessage () {
        return this._receivedMessage;
    }
    getRecievedCommand () {
        return this._receivedCommand;
    }
    getRecievedRadar () {
        return this._receivedRadar;
    }
    getRecievedSensorName () {
        return this._receivedSensorName;
    }
    getRecievedSensorAction () {
        return this._receivedSensorAction;
    }
    getRooms () {
        let roomText = '';
        for (let i = 0; i < this._rooms.length; i++) {
            roomText = `${roomText + i.toString()}:${this._rooms[i].name}\n`;
        }
        if (roomText){
            return roomText;
        }
        return '部屋情報がありません。';
        
    }
    fullWidthToHalfWidth (str) {
        return str.replace(/[０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0));
    }
    setRoomIndex (args) {
        if (!this._access_token) {
            alert('リフレッシュトークンを設定してください。');
            return;
        }
        const index = parseInt(args.TEXT) || 0; // NOTE: 数字にCastが失敗した場合は0が入る
        if (index > this._rooms.length) {
            this._room_index = 0;
            alert('数字が部屋数を超えています。');
            return this._rooms[this._room_index].name;
        }
        if (index < 0) {
            alert('数字に負の数が入力されています');
            return;
        }
        this._room_index = index;
        return this._rooms[this._room_index].name;
    }
    async sendText (args) {
        if (!this._access_token) {
            alert('リフレッシュトークンを設定してください。');
            return;
        }
        const text = Cast.toString(args.TEXT);
        const url = `${BASE_URL}/v1/rooms/${
            this._rooms[this._room_index].uuid
        }/messages/text`;

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${this._access_token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({text: text})
        })
            .then(async res => {
                if (res.status === 429) {
                    throw new Error(
                        '制限に到達しました。しばらく待ってから実行してください。'
                    );
                }
                if (res.status === 400) {
                    throw new Error('1-250文字を入力してください。');
                }
                if (res.status === 401) {
                    alert(config.messages.unauthorized);
                }
                const data = await res.json();
                this._requestId = data.unique_id;
            })
            .catch(error => {
                console.error('Error:', error);
                alert(error);
            });
    }
    changeLed (args) {
        if (!this._access_token) {
            alert('リフレッシュトークンを設定してください。');
            return;
        }
        const red = Cast.toNumber(args.RED);
        const green = Cast.toNumber(args.GREEN);
        const blue = Cast.toNumber(args.BLUE);
        const url = `${BASE_URL}/v1/rooms/${
            this._rooms[this._room_index].uuid
        }/motions/led_color`;
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Authorization': `Bearer ${this._access_token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({red: red, green: green, blue: blue})
        })
            .then(res => {
                if (res.status === 429) {
                    throw new Error(
                        '制限に到達しました。しばらく待ってから実行してください。'
                    );
                }
                if (res.status === 400) {
                    throw new Error(
                        'ほっぺの色の値は、0-255の値を入れてください。'
                    );
                }
                if (res.status === 401) {
                    alert(config.messages.unauthorized);
                }
                return res.json();
            })
            .catch(error => {
                console.error('Error:', error);
                alert(error);
            });
    }

}
module.exports = Scratch3Emo;
